import { createDate } from "@/utils";
import dayjs from "dayjs";

interface ValidDatesProps {
    calendar: {
        [key: string]: number;
    }[];
    checkIn: string;
    checkOut: string | undefined;
    title: {
        year: number;
        month: number;
    };
}

interface ValidDatesResult {
    date: number | false;
    comparisonDate: string;
    getTimeComparisonDate: number;
    isCurrentDateValid: boolean;
    isCheckIn: boolean;
    isCheckOut: boolean;
    isBetween: boolean;
}

export const generatedValidDates = ({ calendar, checkIn, checkOut, title }: ValidDatesProps) => {
    const { year, month } = title;
    const { currentObj } = createDate();

    const newCalendarDates = calendar.map((calendar): ValidDatesResult => {
        const date = calendar.date > 0 && calendar.date;
        const comparisonDate = `${year}-${month.toString().padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
        const getTimeComparisonDate = dayjs(comparisonDate).valueOf();
        const isCurrentDateValid = getTimeComparisonDate < currentObj.valueOf();
        const isCheckIn = checkIn === comparisonDate;
        const isCheckOut = checkOut === comparisonDate;
        const isBetween =
            dayjs(checkIn).valueOf() < getTimeComparisonDate && dayjs(checkOut).valueOf() > getTimeComparisonDate;

        return { date, comparisonDate, getTimeComparisonDate, isCurrentDateValid, isCheckIn, isCheckOut, isBetween };
    });

    return { newCalendarDates };
};
